import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../BaseUrl";

export const getProIssueReport = createAsyncThunk(
    "/prosafe/getProIssueReport",
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/pro-issue-report`;

            const response = await axios({
                method: "post",
                url: myurl,
                data: payload,
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("PAY_USER_TOKEN"),
                },
            });

            const data = response.data;

            if (data.success === true) {
                return data;
            } else {
                throw new Error(data?.message || "Failed to fetch issue report");
            }
        } catch (error) {
            toast.error(error?.response?.data?.message || error?.message || "Failed to fetch issue report");
            throw error;
        }
    }
);

const getProIssueReportSlice = createSlice({
    name: "getProIssueReport",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getProIssueReport.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getProIssueReport.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getProIssueReport.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    },
});

export default getProIssueReportSlice.reducer;
